import { compareHelpers } from '@approvalmax/utils';
import setWith from 'lodash/setWith';
import { backend } from 'modules/data';
import { DeepenObj } from 'modules/data/utils/types';

/**
 * Perform data customization due to the specifics of the response of Airwallex
 * @param data
 */
export const tuneAirwallexFieldsAnswer = (data: backend.AirwallexBeneficiarySchemaAnswer) => {
    const isAUBpay =
        data.schema.condition.bank_country_code === 'AU' &&
        data.schema.condition.payment_method === 'LOCAL' &&
        data.schema.condition.local_clearing_system === 'BPAY';

    return data.schema.fields.map((item) => {
        let label = item.field.label;
        let description = item.field.description;
        let enabled = item.enabled;
        let fieldDefault = item.field.default;
        let path = item.path;
        let required = item.required;
        let options: typeof item.field.options | undefined = undefined;

        if (item.path === 'beneficiary.bank_details.local_clearing_system') {
            label = 'Local clearing system';
        }

        if (item.path === 'beneficiary.bank_details.account_routing_value2' && isAUBpay) {
            label = 'Customer reference number (CRN)';
            description = '';
        }

        if (item.path === 'beneficiary.bank_details.account_routing_type2' && isAUBpay) {
            enabled = false;
            fieldDefault = 'bpay_customer_reference';
        }

        if (item.path === 'payment_method') {
            path = 'payment_methods';
        }

        if (item.path === 'beneficiary.bank_details.local_clearing_system') {
            required = true;
        }

        if (item.field.options) {
            options = item.field.options.sort((optionA, optionB) =>
                compareHelpers.stringComparator2Asc(optionA.label, optionB.label)
            );
        }

        return {
            ...item,
            enabled,
            path,
            required,
            field: {
                ...item.field,
                description,
                label,
                default: fieldDefault,
                options,
            },
        };
    });
};

/**
 * transform {'path.with.dots': 'any value'} to
 *  {
 *      path: {
 *          with: {
 *              dots: 'any value'
 *          }
 *      }
 *   }
 * @param obj
 */
export const deepen = (obj: Record<string, string>): DeepenObj => {
    const result = {};

    for (const objectPath in obj) {
        setWith(result, objectPath, obj[objectPath], Object);
    }

    return result;
};
